import { render } from "./IconPDF.vue?vue&type=template&id=2ff8aae0"
import script from "./IconPDF.vue?vue&type=script&lang=ts"
export * from "./IconPDF.vue?vue&type=script&lang=ts"
script.render = render

export default script